import { GroupedActivitySelect } from './GroupedActivitySelect';
import { VibrationModeSelect } from './VibrationModeSelect';
import {
  type ActivityType,
  type VibrationMode,
} from '@/types/activity';
import { DateRangePicker } from '@/components/ui/DateRangePicker';

interface ActivityFiltersProps {
  activityTypes: ActivityType[];
  vibrationModes: VibrationMode[];
  availableVibrationModes: VibrationMode[];
  currentlyAvailableVibrationModes: Set<VibrationMode>;
  dateRange?: {
    from: string | null;
    to: string | null;
  };
  onActivityTypesChange: (types: ActivityType[]) => void;
  onVibrationModesChange: (modes: VibrationMode[]) => void;
  onDateRangeChange?: (from: string | null, to: string | null) => void;
}

export function ActivityFilters({
  activityTypes,
  vibrationModes,
  availableVibrationModes,
  currentlyAvailableVibrationModes,
  dateRange,
  onActivityTypesChange,
  onVibrationModesChange,
  onDateRangeChange,
}: ActivityFiltersProps) {
  const hasDateRange = Boolean(dateRange && onDateRangeChange);

  return (
    <div className={hasDateRange ? 'grid gap-4 md:grid-cols-2 lg:grid-cols-3' : 'grid gap-4 md:grid-cols-2'}>
      <div>
        <label className="mb-2 block text-sm font-medium text-foreground">
          Activity Type
        </label>
        <GroupedActivitySelect
          selected={activityTypes}
          onChange={onActivityTypesChange}
        />
      </div>

      <div>
        <label className="mb-2 block text-sm font-medium text-foreground">
          Vibration Mode
        </label>
        <VibrationModeSelect
          modes={availableVibrationModes}
          currentlyAvailableModes={currentlyAvailableVibrationModes}
          selected={vibrationModes}
          onChange={onVibrationModesChange}
        />
      </div>

      {dateRange && onDateRangeChange && (
        <div>
          <label className="mb-2 block text-sm font-medium text-foreground">
            Date Range
          </label>
          <DateRangePicker
            from={dateRange.from}
            to={dateRange.to}
            onChange={onDateRangeChange}
          />
        </div>
      )}
    </div>
  );
}
